var exports = {
  "x6": "xa15a2ab7--91c36f--button",
  "Qs": "xa15a2ab7--91c36f--content",
  "qT": "xa15a2ab7--91c36f--features",
};

module.exports = exports;
